var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"title":"TeamBot"}},[_c('router-view'),_c('LoadingScreen',{attrs:{"show":_vm.loading}}),_c('snackbar',{attrs:{"color":_vm.snackColor,"snackbar":_vm.snackShow,"text":_vm.snackText}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }